import {Injectable} from '@angular/core';
import {AuthService} from 'app/core/auth/auth.service';
import {HttpClient} from '@angular/common/http';
import {environment} from 'environments/environment';
import {AllLocationResponse, AllLocationResponsePagination} from '../models/location.types';
import {BehaviorSubject, Observable} from 'rxjs';
import {DateTime, Interval} from "luxon";

@Injectable({
    providedIn: 'root'
})
export class LocationService {
    public locationDetail = new BehaviorSubject<AllLocationResponse>(null);
    currentLocation = this.locationDetail.asObservable();

    constructor(
        private authService: AuthService,
        private httpClient: HttpClient) {
    }


    fetchAllLocationForOrgUserV2(locationName = '', pageNumber = 0): Observable<AllLocationResponsePagination> {
        return this.httpClient.get<AllLocationResponsePagination>(`${environment.BASE_URL}location/v2/listAllLocationForOrgUserV2/${this.authService.businessUser.orgId}/${this.authService.businessUser.userId}?locationName=${locationName}&pageNumber=${pageNumber}`);
    }

    get currentLocationDetail(): AllLocationResponse {
        return this.getLocalStorage('current_location');
    }

    set currentLocationDetail(location: AllLocationResponse) {
        localStorage.setItem('current_location', JSON.stringify(location));
        this.locationDetail.next(location);
    }

    getLocalStorage(key): any {
        try {
            return JSON.parse(localStorage.getItem(key));
        } catch (e) {
            console.error('Error getting data local storage Data', e);
            return null;
        }
    }

    disableLocation(locationId: string) {
        return this.httpClient.delete(`${environment.BASE_URL}location/disableLocation/${locationId}`);
    }

    getSetupDelay(): number {
        let setupDelayInMinutes: number;
        const setupLocationId = localStorage.getItem('setupLocationId');
        const setupDate = localStorage.getItem('setupDate');
        if (setupDate && this.currentLocationDetail && setupLocationId == this.currentLocationDetail.locationId) {
            setupDelayInMinutes = Interval.fromDateTimes(DateTime.fromISO(setupDate), DateTime.now()).length('minutes');
        } else {
            setupDelayInMinutes = 8;
        }
        return setupDelayInMinutes;
    }
}
